import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HeaderService } from 'onego-header';
import { Observable, switchMap } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppStateService } from '../services/state';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
    private readonly appState = inject(AppStateService);
    private readonly headerService = inject(HeaderService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const tenant = this.appState.activeTenant.value;
        if (!tenant) {
            return next.handle(req);
        }

        return this.headerService.config.pipe(
            take(1),
            switchMap((config) => {
                if (!req.url.includes(config.keycloakUrl)) {
                    req = req.clone({ headers: req.headers.set('OneGo-Tenant', tenant.id) });
                }
                return next.handle(req);
            })
        );
    }
}
